import React from 'react'
import { Spinner } from 'reactstrap'
import styles from "./TxSpinner.styles"
import './directcss/TxSpinner.scss'

export const TxSpinner = ({ message = "", customStyles = {}, isFullWidth = false }) => {
    return (
        <div style={{...styles.spinner, ...(!isFullWidth ? {width: 'auto'} : {} )}}>
            <Spinner style={customStyles} className={"tx-spinner"} />
            {message?.length > 0 && <span>{message}</span>}
        </div>
    )
}
